import { createSelector } from "reselect"

const uiState = state => state.ui

export const getPreviousRoute = createSelector(
  uiState,
  state => state.previousRoute
)
